export default "__VITE_ASSET__RL4suiZz__"